import React from "react";
import "./nav.css";
import { IoDocumentText } from "react-icons/io5";
import { MdBusinessCenter, MdWifiCalling3 } from "react-icons/md";
import { FaQuoteLeft,FaHandshake } from "react-icons/fa";
import profile from "../../assets/nikesh.png";
import facebook from "../../assets/facebook.png";
import instagram from "../../assets/instagram.png";
import github from "../../assets/github.png";
const index = () => {
  return (
    <div className="navBarContainer">
      <div className="profile">
        <a href="#home">
          <img src={profile} alt="profile " />
        </a>
      </div>
      <div className="navItems">
        <a href="#about">
          <div className="item1">
            <IoDocumentText
              className="navIcons"
              color="#a52a2a"
              size={32}
              cursor="pointer"
            />
            <span>About</span>
          </div>
        </a>
        <a href="#services">
          <div className="item2">
            <FaHandshake
              className="navIcons"
              color="#ff4400d3"
              size={32}
              cursor="pointer"
            />
            <span>Services</span>
          </div>
        </a>
        <a href="#portfolio">
          <div className="item3">
            <MdBusinessCenter
              color="#28abe1"
              size={32}
              cursor="pointer"
              className="navIcons"
            />
            <span>Portfolio</span>
          </div>
        </a>
        <a href="#testimonial">
          <div className="item4">
            <FaQuoteLeft
              color="#ffc455"
              size={28}
              cursor="pointer"
              className="navIcons"
            />
            <span>Testimonial</span>
          </div>
        </a>
        <a href="#contact">
          <div className="item5">
            <MdWifiCalling3
              color="#ff754a"
              size={32}
              cursor="pointer"
              className="navIcons"
            />
            <span>Contact</span>
          </div>
        </a>
      </div>
      <div className="socialLinks">
        <h2>Follow Me</h2>
        <div className="underline"></div>
        <a href="https://github.com/nikeshpyakurel">
          <img src={github} alt="github" />
        </a>
        <a href="https://www.facebook.com/nikeshpyaku">
          <img src={facebook} alt="facebook" />
        </a>
        <a href="https://www.instagram.com/nikesh.pyakurel/">
          <img src={instagram} alt="instagram" />
        </a>
      </div>
    </div>
  );
};

export default index;
